export default __webpack_public_path__ + "static/media/gymImage.2c421301.svg";